export default __webpack_public_path__ + "static/media/ladrillos-consejo-3.d70afe42.jpg";